import { isTpvcaMandatorySlug } from '@/utils/tpvcaInsurance';
import { isKaskoInsuranceSlug } from '@/utils/kaskoInsurance';
import { isTravelInsuranceSlug } from '@/utils/travelInsurance';
/**
 * Step structure and "previous step" navigation aligned with StepperFooter.handleBack
 * (calculator route slug from /skaiciuokle/[insurance]).
 */

import { isBicycleInsuranceSlug } from '@/utils/bicycleInsurance';
import { isPcaInsuranceSlug } from '@/utils/pcaInsurance';
import {
  isHealthInsuranceSlug,
  isRoadsideInsuranceSlug,
  isPavezejoInsuranceSlug,
  isConstructionCarSlug,
} from '@/utils/calculatorProductSlugs';
import { isSpecialMachineryInsuranceSlug } from '@/utils/specialMachineryInsurance';

export function getStepStructureForSlug(slug) {
  const isHealthInsurance = isHealthInsuranceSlug(slug);
  const isBicycleInsurance = isBicycleInsuranceSlug(slug);
  const isRoadsideInsurance = isRoadsideInsuranceSlug(slug);
  const isConstructionInsurance =
    isConstructionCarSlug(slug) || isPcaInsuranceSlug(slug);

  if (isHealthInsurance || isBicycleInsurance) {
    return {
      loaderStep: null,
      summaryStep: 7,
      stepBeforeSummary: 5,
    };
  }
  if (isRoadsideInsurance) {
    return {
      loaderStep: 1,
      summaryStep: 7,
      stepBeforeLoader: 5,
      stepBeforeSummary: 5,
    };
  }
  const isTravelInsurance = isTravelInsuranceSlug(slug);
  const isKaskoInsurance = isKaskoInsuranceSlug(slug);
  const isSpecialMachineryInsurance = isSpecialMachineryInsuranceSlug(slug);
  const isTpvcaMandatory = isTpvcaMandatorySlug(slug);
  const isCargoDriverInsurance = isPavezejoInsuranceSlug(slug);

  if (isConstructionInsurance) {
    return {
      loaderStep: null,
      summaryStep: 7,
      stepBeforeSummary: 0,
    };
  }
  if (isSpecialMachineryInsurance) {
    return {
      loaderStep: 1,
      summaryStep: 7,
      stepBeforeLoader: 0,
      stepBeforeSummary: 2,
    };
  }
  if (isTravelInsurance) {
    return {
      loaderStep: 6,
      summaryStep: 7,
      stepBeforeLoader: 5,
    };
  }
  if (isKaskoInsurance || isTpvcaMandatory || isCargoDriverInsurance) {
    return {
      loaderStep: 7,
      summaryStep: 8,
      stepBeforeLoader: 6,
    };
  }
  return {
    loaderStep: 6,
    summaryStep: 7,
    stepBeforeLoader: 5,
  };
}

/**
 * @returns {{ nextStep: number | null, exitToHome: boolean }}
 */
export function getPreviousStepIndex(step, slug) {
  const stepStructure = getStepStructureForSlug(slug);
  const isTravelInsurance = isTravelInsuranceSlug(slug);
  const isCargoDriverInsurance = isPavezejoInsuranceSlug(slug);
  const isKaskoInsurance = isKaskoInsuranceSlug(slug);
  const isTravelOrCargoDriver = isTravelInsurance || isCargoDriverInsurance;
  const isExtendedCarFlow =
    isKaskoInsurance ||
    isTpvcaMandatorySlug(slug) ||
    isPavezejoInsuranceSlug(slug);

  if (step === 0) {
    return { nextStep: null, exitToHome: true };
  }

  if (
    (isHealthInsuranceSlug(slug) ||
      isBicycleInsuranceSlug(slug) ||
      isRoadsideInsuranceSlug(slug)) &&
    step === 3
  ) {
    return { nextStep: 0, exitToHome: false };
  }
  if (isRoadsideInsuranceSlug(slug) && step === 1) {
    return { nextStep: 5, exitToHome: false };
  }
  if (
    (isHealthInsuranceSlug(slug) ||
      isBicycleInsuranceSlug(slug) ||
      isRoadsideInsuranceSlug(slug)) &&
    step === 5
  ) {
    return { nextStep: 0, exitToHome: false };
  }

  if (step === stepStructure.summaryStep) {
    if (typeof stepStructure.stepBeforeSummary === 'number') {
      return { nextStep: stepStructure.stepBeforeSummary, exitToHome: false };
    }
    if (typeof stepStructure.stepBeforeLoader === 'number') {
      return { nextStep: stepStructure.stepBeforeLoader, exitToHome: false };
    }
    return { nextStep: 0, exitToHome: false };
  }

  if (
    stepStructure.loaderStep !== null &&
    stepStructure.loaderStep !== undefined &&
    step === stepStructure.loaderStep
  ) {
    if (typeof stepStructure.stepBeforeLoader === 'number') {
      return { nextStep: stepStructure.stepBeforeLoader, exitToHome: false };
    }
  }

  if (isTravelInsuranceSlug(slug) && step === 5) {
    return { nextStep: 4, exitToHome: false };
  }
  if (isTravelOrCargoDriver && step === 5) {
    return { nextStep: 3, exitToHome: false };
  }
  if (isExtendedCarFlow && step === 5) {
    return { nextStep: 3, exitToHome: false };
  }
  if (isExtendedCarFlow && step === 6) {
    return { nextStep: 5, exitToHome: false };
  }
  if (isExtendedCarFlow && step === 7) {
    return { nextStep: 6, exitToHome: false };
  }
  if (isExtendedCarFlow && step === 8) {
    return { nextStep: 7, exitToHome: false };
  }
  if (step === 5 && !isTravelOrCargoDriver && !isKaskoInsurance) {
    return { nextStep: 3, exitToHome: false };
  }
  if (isKaskoInsurance && step === 2) {
    return { nextStep: 0, exitToHome: false };
  }
  if (
    (isTpvcaMandatorySlug(slug) ||
      isCargoDriverInsurance) &&
    step === 2
  ) {
    return { nextStep: 0, exitToHome: false };
  }
  if (step === 4) {
    return { nextStep: 3, exitToHome: false };
  }
  if (step > 0) {
    return { nextStep: step - 1, exitToHome: false };
  }

  return { nextStep: null, exitToHome: true };
}
